import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { RevenueTemplate } from 'components/Templates'

const RealtimeRevenue: FC = () => {
  return (
    <Layout headline={'売上確認'} iconPath={'/icon/white/revenue.svg'} title={'売上確認'}>
      <RevenueTemplate />
    </Layout>
  )
}

export default RealtimeRevenue
